import { call, put, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { selectProductPriceCategory } from 'features/product-info';
import { selectProductBelong, selectProductId, selectProductName, selectProductPrice } from './selectors';
import { GaProductBelong } from './types';

/**
 * Событие должно срабатывать при отображении пользователю кнопки "Рассчитать количество"
 */

export const CALCULATE_QUANTITY_GA_SHOW = createAction('CALCULATE_QUANTITY_GA_SHOW')<{
  elementText: string;
}>();

export const gaCalculateQuantityShow = createAction('GA:show')<{
  elementType: string;
  elementBlock: string; // блок, в котором расположен элемент
  elementText: string;
  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productTag: string; // bestPrice для “Лучшей цены” и onlineOnly для “Только онлайн заказ”, а также остальные бейджи. При наличии нескольких передавать через разделитель “,”
  productBelong: GaProductBelong; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, LeroyMerlin - для товаров Леруа Мерлен
}>();

function* putGaCalculateQuantityShow(elementText: string) {
  yield put(
    gaCalculateQuantityShow({
      elementType: 'button',
      elementBlock: 'productDetail',
      elementText,
      productName: yield call(selectProductName),
      productId: yield call(selectProductId),
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      productTag: yield call(selectProductPriceCategory),
    }),
  );
}

export function* runCalculateQuantityShowDetector() {
  yield takeEvery(CALCULATE_QUANTITY_GA_SHOW, ({ payload: { elementText } }) =>
    putGaCalculateQuantityShow(elementText),
  );
}
